import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import DailyAttendance from './pages/DailyAttendance';
import StaffPage from './pages/StaffPage';
import ReportPage from './pages/ReportPage';
import StaffAttendance from './pages/StaffAttendance';
import LoginPage from './pages/LoginPage';

function App() {
  const [user, setUser] = useState<{id: number, name: string, role: 'admin' | 'staff'} | null>(null);

  return (
    <Router>
      <div className="min-h-screen bg-slate-50 font-sans text-slate-800 antialiased">
        {user && <Navbar userRole={user.role} setUser={setUser} />}
        
        <main className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <Routes>
            {/* PUBLIC ROUTE: Yeh link koi bhi khol sakega (Direct Link) */}
            <Route path="/mark-attendance/:empId" element={<StaffAttendance />} />

            {!user ? (
              <>
                <Route path="/login" element={<LoginPage setUser={setUser} />} />
                <Route path="*" element={<Navigate to="/login" />} />
              </>
            ) : (
              <>
                {/* ADMIN ROUTES */}
                {user.role === 'admin' && (
                  <>
                    <Route path="/" element={<DailyAttendance isAdmin={true} />} />
                    <Route path="/staff" element={<StaffPage isAdmin={true} />} />
                    <Route path="/report" element={<ReportPage />} />
                  </>
                )}
                
                {/* STAFF LOGIN REDIRECT: Login ke baad seedha apne punch page par */}
                {user.role === 'staff' && (
                  <Route path="*" element={<Navigate to={`/mark-attendance/${user.id}`} />} />
                )}
                
                <Route path="*" element={<Navigate to="/" />} />
              </>
            )}
          </Routes>
        </main>
      </div>
    </Router>
  );
}
export default App;